<template>
  <div class="page-account-records" ref="records">
    <bCardRecordHeader :param="params" @getradeAccount="getAccountNumberChange"></bCardRecordHeader>
    <div class="card-base card-shadow--small records">
      <bTabsRouter ref="recordsTab" :tabs="tabs" @totalPage-pageSize="getPageSizeAndTctal" @getTabName="getTabName"
        :loading="loading" :activeName.sync="activeName" :number="tradeAccount" :depositThs="depositThsArr" :count="count" :datas="datas" @export-fun="exportFun"
        @search-fun="searchFun">
      </bTabsRouter>
    </div>
  </div>
</template>

<script>
import depositThs from '../../table-config/deposit'
import withdrawalThs from '../../table-config/withdrawal'
import transferThs from '../../table-config/transfer'
import depositTab from './deposit-tab.vue'
import withdrawalTab from './withdrawal-tab.vue'
import moment from 'moment'
import internalTransferTab from './internal-transfer-tab.vue'
import exchangeTab from './exchange-tab.vue'
import { mapGetters } from 'vuex'
import fundRecordRequest from '@/api/v2/fundRecord'
import _ from 'lodash'
export default {
  data () {
    return {
      datas: {
        depositData: [],
        withdrawalData: [],
        transferData: [],
        exchangeData: []
      },
      tradeAccount: '',
      tradeAccountType: '',
      startDate: '',
      endDate: '',
      pageDatas: [{
        name: 'deposit',
        totalPage: 1,
        pageSize: 15
      },
      {
        name: 'withdrawal',
        totalPage: 1,
        pageSize: 15
      },
      {
        name: 'transfer',
        totalPage: 1,
        pageSize: 15
      },
      {
        name: 'exchangeRecords',
        totalPage: 1,
        pageSize: 15
      }
      ],
      loading: true,
      activeName: 'deposit',
      params: {
        title: 'records',
        links: [{
          title: 'home'
        },
        {
          title: 'my_account'
        },
        {
          title: 'records'
        },
        {
          title: 'deposit'
        }
        ]
      },
      count: {
        deposit: 0,
        withdrawal: 0,
        transfer: 0,
        exchangeRecords: 0
      },
      tabs: [{
        label: this.$t('headerCard.breadcrumb.deposit'),
        title: 'deposit',
        currTab: depositTab,
        disabled: false
      },
      {
        label: this.$t('headerCard.breadcrumb.withdrawal'),
        title: 'withdrawal',
        currTab: withdrawalTab,
        disabled: false
      },
      {
        label: this.$t('headerCard.breadcrumb.transfer'),
        title: 'transfer',
        currTab: internalTransferTab,
        disabled: false
      },
      {
        label: this.$t('headerCard.breadcrumb.exchangeRecords'),
        title: 'exchangeRecords',
        currTab: exchangeTab,
        disabled: false
      }
      ],
      depositThs: JSON.parse(JSON.stringify(depositThs)),
      depositThsArr: JSON.parse(JSON.stringify(depositThs))
    }
  },
  mounted () {
    this.activeName = this.$route.query.activeName || 'deposit'
    this.params.links[this.params.links.length - 1].title = this.$t(
      'headerCard.breadcrumb.' + this.activeName
    )
    this.getAccountNumberChange({})
    // console.log(this.activeName)
    // if (this.$store.getters.valueAccountNumber) {
    //   this.number = this.$store.getters.valueAccountNumber

    // }
  },

  computed: {
    ...mapGetters(['getAccountInfo']),
    // ...mapState(['accountInfo']),
    tradeAccountList () {
      return this.getAccountInfo
    }
  },
  methods: {
    tradeAccountConfig (tradeAccountType) {
      return this.Util.getTradeAccountConfig(tradeAccountType)
    },
    getAccountNumberChange (val) {
      try {
        // let tradeAccountObj = this.tradeAccountList.find((item) => {
        //   return item.tradeAccountNumber === val
        // })
        // if (!this.tradeAccountConfig(tradeAccountObj.tradeAccountNumber)['isTradeAccountExit']) {
        //   throw { code: '5003', msg: 'tradeAccountType is lost' }
        // }
        this.tradeAccount = val.tradeAccountNumber
        this.tradeAccountType = val.tradeAccountType
        if (val.tradeAccountType === 'MT5' || !val.tradeAccountType) {
         this.depositThsArr.splice(5, 0, {
            label: 'exchangeAmount',
            name: 'exchangeAmount',
            width: '',
            exportwidth: '20',
            sortable: true
          })
          console.log(this.depositThsArr, 'this.depositThsArr')
        } else {
          if (this.depositThsArr[5].name === 'exchangeAmount' && val.tradeAccountType !== 'MT5') {
            this.depositThsArr.splice(5, 1)
          } else {
            this.depositThsArr = this.depositThs
          }
        }
        // this.depositThsArr = this.depositThs
        this.$refs.recordsTab.setPageSize()
        // this.getAllData(this.pageDatas[0], this.activeName)
      } catch (error) {
        console.log('>>>>error', error)
        let message = this.$t(`errMessage.${error.code}`)
        this.$message({
          showClose: true,
          message: message,
          type: 'error'
        })
      }
    },

    getAllData (pageData, model) {
      // if (!this.tradeAccount) {
      //   return this.openMessage('error', this.$t('errMessage.417'))
      // }
      if (!this.$refs['recordsTab'].endDate || !this.$refs['recordsTab'].startDate) {
        // return this.$message.error(this.$t('records.chooseTime'))
        return this.openMessage('error', this.$t('records.chooseTime'))
      }
      if (
        new Date(this.$refs['recordsTab'].endDate) <
          new Date(this.$refs['recordsTab'].startDate)
      ) {
        return this.openMessage('error', this.$t('errMessage.414'))
      }
      this.loading = true
      // this.updateTabsStatus(true)
      // let funName = this.getFunName(this.activeName)
      // console.log('>>>>>>>>>>>funName', funName)
      // let options = {
      //   limit: 15,
      //   offset: 0,
      //   searchParams: {},
      //   startDate: Date.parse(this.$refs['recordsTab'].startDate),
      //   endDate: Date.parse(this.$refs['recordsTab'].endDate),
      //   sortKey: 'createdTime',
      //   sortVal: '-1'
      // }
      // options = this.formatOptions(this.activeName, options, number)
      let params = this.formatParams(this.tradeAccount, this.activeName, pageData)
      fundRecordRequest.getDepositRecords(params).then(res => {
         this.loading = false
         this.updateTabsStatus(false)
         let data = res.data && res.data.results.map(item => {
           item.createdDate = moment(item.createdDate).format('YYYY-MM-DD')
           return item
         })
         this.datas[this.getDatasName(this.$refs['recordsTab'].activeName)] = data
         this.count[this.$refs['recordsTab'].activeName] = res.data.totalCount
      })
      // this.$api[funName](options).then(result => {
      //   this.loading = false
      //   this.updateTabsStatus(false)
      //   this.datas[
      //     this.getDatasName(this.$refs['recordsTab'].activeName)
      //   ] = this.momentFormat(result.data.rows, this.activeName)
      //   this.count[this.$refs['recordsTab'].activeName] = result.data.count
      // })
    },
    formatParams (number, recordTpye, pageData) {
      // if (!number) {
      //   // eslint-disable-next-line no-throw-literal
      //   throw '请选择交易账号账号'
      // }

      let params = {
        startTime: moment(this.$refs['recordsTab'].startDate).format('YYYY-MM-DD') + 'T00:00:00',
        endTime: moment(this.$refs['recordsTab'].endDate).format('YYYY-MM-DDTHH:mm:ss'),
        pageIndex: pageData.totalPage,
        pageSize: pageData.pageSize,
        tradeAccountType: this.tradeAccountType,
        tradeRecord: recordTpye,
        tradeAccountNumber: this.tradeAccount
      }
      switch (recordTpye) {
        case 'deposit':
          Object.assign(params, { tradeRecord: 'DEPOSIT_RECORD' })
          break
        case 'withdrawal':
          Object.assign(params, { tradeRecord: 'WITHDRAWAL_RECORD' })
          break
        case 'transfer':
          Object.assign(params, { tradeRecord: 'TRANSFER_RECORD' })
          break
        case 'exchangeRecords':
          Object.assign(params, { tradeRecord: 'CURRENCY_EXCHANGE_RECORD' })
          break
      }
      return params
    },
    // formatOptions (activeName, options, number) {
    //   switch (activeName) {
    //     case 'deposit':
    //       options.searchParams.tradeAccount = number
    //       return options
    //     case 'withdrawal':
    //       options.searchParams.tradeAccount = number
    //       return options
    //     case 'transfer':
    //       options.searchParams.outAccount = number
    //       return options
    //   }
    // },
    getFunName (tabName) {
      switch (tabName) {
        case 'deposit':
          return 'getDepositRecords'
        case 'withdrawal':
          return 'getWithdrawalRecords'
        case 'transfer':
          return 'getTransferRecords'
        case 'exchangeRecords':
          return 'getExchangeRecords'
      }
    },
    getDatasName (tabName) {
      switch (tabName) {
        case 'deposit':
          return 'depositData'
        case 'withdrawal':
          return 'withdrawalData'
        case 'transfer':
          return 'transferData'
        case 'exchangeRecords':
          return 'exchangeData'
      }
    },
    getPageSizeAndTctal (val) {
      let model = this.activeName
      console.log(model)
      let obj = _.find(this.pageDatas, {
        name: model
      })
      obj.totalPage = val[0] // 当前页码
      obj.pageSize = val[1] // 当前页面最大数量
      // this.getPageData(obj, model)
      this.getAllData(obj, model)
    },
    getPageData (obj, model) {
      // this.getAllData()
      // if (!this.tradeAccount) {
      //   return this.openMessage('error', this.$t('errMessage.417'))
      // }
      // if (
      //   new Date(this.$refs['recordsTab'].endDate) <
      //     new Date(this.$refs['recordsTab'].startDate)
      // ) {
      //   return this.openMessage('error', this.$t('errMessage.414'))
      // }
      // this.loading = true
      // this.updateTabsStatus(true)
      // let offset = Number(obj.totalPage - 1) * obj.pageSize
      // let options = {
      //   limit: obj.pageSize,
      //   offset: offset,
      //   searchParams: {},
      //   startDate: Date.parse(this.$refs['recordsTab'].startDate),
      //   endDate: Date.parse(this.$refs['recordsTab'].endDate),
      //   sortKey: 'createdTime',
      //   sortVal: '-1'
      // }
      // options = this.formatOptions(this.activeName, options, this.tradeAccount)
      // this.$api[this.getFunName(model)](options)
      //   .then(result => {
      //     this.updateTabsStatus(false)
      //     if (!result.data.rows && !result.data.rows.length) {
      //       return (this.loading = false)
      //     }
      //     let obj = result.data
      //     this.count[model] = obj.count
      //     this.datas[model + 'Data'] = this.momentFormat(obj.rows, model)
      //     this.loading = false
      //   })
      //   .catch(error => {})
    },
    momentFormat (data, type) {
      for (let i = 0; i < data.length; i++) {
        switch (type) {
          case 'deposit':
            if (!data[i].exchangedAmount) {
              data[i].exchangedAmount = '--'
            } else {
              data[i].exchangedAmount =
                  data[i].exchangedCurrency +
                  ' ' +
                  this.Util.formatCurrency(data[i].exchangedAmount)
            }
            break
          case 'withdrawal':
            if (!data[i].exchangedAmount) {
              data[i].exchangedAmount = '--'
            } else {
              data[i].exchangedAmount =
                  data[i].exchangedCurrency +
                  ' ' +
                  this.Util.formatCurrency(data[i].exchangedAmount)
            }
            break
          case 'transfer':
            if (!data[i].outAmount) {
              data[i].outAmount = '--'
            } else {
              data[i].outAmount =
                  data[i].outCurrency +
                  ' ' +
                  this.Util.formatCurrency(data[i].outAmount)
            }
            break
        }
        if (!data[i].remark) {
          data[i].remark = '--'
        }
        if (!data[i].statusKey) {
          data[i].status = '--'
        } else {
          data[i].status = type === 'withdrawal' && data[i].statusKey === 'completed' ? 'withdrawal' + this.getStatus(
            data[i].statusKey) : this.getStatus(data[i].statusKey)
        }

        // if(data[i].outAmount){
        //   data[i].balance = data[i].balance
        // }
        data[i].updatedTime = moment(new Date(data[i].updatedTime)).format(
          'YYYY-MM-DD HH:mm:ss'
        )
      }
      return data
    },
    getStatus2 (status) {
      if (['deposit', 'transfer'].includes(this.activeName)) {
        switch (status) {
          case 'completed':
            return this.$t('records.status.completed')
          case 'verified':
            return this.$t('records.status.submitted')
          case 'checking':
            console.log(this.$t('records.status.checking'), 'ssss')
            return this.$t('records.status.checking')
          case 'processing':
            return this.$t('records.status.submitted')
          case 'submitted':
            return this.$t('records.status.submitted')
          case 'failure':
            return this.$t('records.status.failure')
          case 'canceled':
            return this.$t('records.status.canceled')
          default:
            return
        }
      }
      switch (status) {
        case 'completed':
          return this.$t('records.status.withdrawalcompleted')
        case 'verified':
          return this.$t('records.status.processing')
        case 'checking':
          return this.$t('records.status.processing')
        case 'processing':
          return this.$t('records.status.processing')
        case 'submitted':
          return this.$t('records.status.submitted')
        case 'failure':
          return this.$t('records.status.failure')
        case 'canceled':
          return this.$t('records.status.canceled')
        default:
      }
    },
    getStatus (status) {
      if (this.activeName === 'deposit') {
        switch (status) {
          case 'completed':
            return 'completed'
          case 'verified':
            return 'submitted'
          case 'checking':
            return 'checking'
          case 'processing':
            return 'submitted'
          case 'submitted':
            return 'submitted'
          case 'failure':
            return 'failure'
          case 'canceled':
            return 'canceled'
          default:
            return
        }
      }
      switch (status) {
        case 'completed':
          return 'completed'
        case 'verified':
          return 'processing'
        case 'checking':
          return 'processing'
        case 'processing':
          return 'processing'
        case 'submitted':
          return 'submitted'
        case 'failure':
          return 'failure'
        case 'canceled':
          return 'canceled'
        default:
          break
      }
    },
    updateTabsStatus (status) {
      for (let i = 0; i < this.tabs.length; i++) {
        this.tabs[i].disabled = status
      }
    },
    getTabName (val) {
      // var obj = _.find(this.tabs, {
      //   title: val
      // })
      this.params.links[this.params.links.length - 1].title = this.$t(
        'headerCard.breadcrumb.' + val
      )
      console.log(this.params)
    },
    searchFun (val) {
    },
    getStartDate (val) {
      this.startDate = val
    },
    getEndDate (val) {
      this.endDate = val
    },
    getParamsUrl (options) {
      let result = '?'
      for (let key in options) {
        if (options[key]) {
          result += key + '=' + options[key] + '&'
        } else {
          result += key + '=&'
        }
      }
      if (result[result.length - 1] === '&') {
        result = result.substring(0, result.length - 1)
      }
      return result
    },
    // TODO 目前是用的前段导出，如果数据量大的话考虑做后端导出
    exportFun (val) {
      console.log(val, 'val')
      if (
        new Date(this.$refs['recordsTab'].endDate) <
          new Date(this.$refs['recordsTab'].startDate)
      ) {
        return this.openMessage('error', this.$t('errMessage.414'))
      }
      this.loading = true
      // this.updateTabsStatus(true)
      // let funName = this.getFunName(this.activeName)
      // console.log('>>>>>>>>>>>funName', funName)
      // let options = {
      //   limit: 15,
      //   offset: 0,
      //   searchParams: {},
      //   startDate: Date.parse(this.$refs['recordsTab'].startDate),
      //   endDate: Date.parse(this.$refs['recordsTab'].endDate),
      //   sortKey: 'createdTime',
      //   sortVal: '-1'
      // }
      // options = this.formatOptions(this.activeName, options, number)
      let params = this.formatParams(this.tradeAccount, this.activeName, this.pageDatas)
      fundRecordRequest.getDepositRecords(params).then(res => {
         this.loading = false
        //  this.updateTabsStatus(false)
         let data = res.data && res.data.results.map(item => {
           item.createdDate = moment(item.createdDate).format('YYYY-MM-DD')
           return item
         })
        //  this.datas[this.getDatasName(this.$refs['recordsTab'].activeName)] = data
        //  this.count[this.$refs['recordsTab'].activeName] = res.data.totalCount
          this.exportExcel(data, val)
      })
      // if (!this.tradeAccount) {
      //   return this.openMessage('error', this.$t('errMessage.417'))
      // }
      // let options = {
      //   searchParams: {},
      //   startDate: Date.parse(this.$refs['recordsTab'].startDate),
      //   endDate: Date.parse(this.$refs['recordsTab'].endDate),
      //   sortKey: 'createdTime',
      //   sortVal: '-1'
      // }
      // options = this.formatOptions(this.activeName, options, this.$store.getters.valueAccountNumber)
      // this.$api[this.getFunName(val)](options)
      //   .then(result => {
      //     let obj = result.data.rows
      //     this.exportExcel(obj, val)
      //   })
      //   .catch(error => {})
    },
    exportExcel (data, val) {
      let exportDatas = this.momentFormat(data, val)
      let ths = []
      let arrItems = {
        depositThs,
        withdrawalThs,
        transferThs
      }
      let arr = arrItems[val + 'Ths']
      let exportDatas1 = []
      let wchs = []
      for (let i = 0; i < arr.length; i++) {
        ths.push(this.$t('records.' + val + '.' + arr[i].name))
        wchs.push({
          wch: arr[i].exportwidth
        })
      }

      exportDatas1.push(ths)
      for (let i = 0; i < exportDatas.length; i++) {
        let datas = []
        for (let j = 0; j < arr.length; j++) {
          if (arr[j].name === 'status') {
            datas.push(this.getStatus2(exportDatas[i][arr[j].name]))
          } else {
            if (exportDatas[i][arr[j].name]) {
              datas.push(exportDatas[i][arr[j].name])
            } else {
              datas.push('--')
            }
          }
        }
        exportDatas1.push(datas)
      }
      console.log('>>>>>>>>exportDatas1', exportDatas1)
      this.$outputXlsxFile(exportDatas1, wchs, val + '_data')
    }
  }
}

</script>

<style lang="scss">
  .page-account-records {
    height: min-content;
  }

  @media (max-width: 768px) {
    .layout-container .container .view {
      max-width: 100%;
      padding: 0 !important;
      margin: 0 !important;
    }
  }

  .records {
    // overflow: auto;
    margin-top: 10px;
  }

</style>
